// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RangeSlider {
  display: block;
  height: 3.5rem;
}
.RangeSlider .RangeSlider-Track {
  display: inline-block;
  height: 0.5rem;
  width: 100%;
  margin: 0;
  padding: 0;
}
.RangeSlider .RangeSlider-Track .RangeSlider-Tick:before {
  content: "";
  position: absolute;
  left: 0;
  background: rgba(0, 0, 0, 0.2);
  height: 5px;
  width: 2px;
  transform: translate(-50%, 0.7rem);
}
.RangeSlider .RangeSlider-Track .RangeSlider-Tick .RangeSlider-TickLabel {
  position: absolute;
  color: rgba(0, 0, 0, 0.5);
  top: 100%;
  transform: translate(-50%, 1.2rem);
  white-space: nowrap;
}
.RangeSlider .RangeSlider-Track .RangeSlider-Tick.first .RangeSlider-TickLabel {
  transform: translate(0, 1.2rem);
}
.RangeSlider .RangeSlider-Track .RangeSlider-Tick.last .RangeSlider-TickLabel {
  transform: translate(-100%, 1.2rem);
}
.RangeSlider .RangeSlider-Track .RangeSlider-Segment {
  height: 100%;
  border: 1px solid #ccc;
}
.RangeSlider .RangeSlider-Track .RangeSlider-Segment .RangeSlider-Segment-Tooltip {
  display: inline-block;
  position: relative;
  top: -2.5rem;
  left: 50%;
  margin: auto;
  padding: 0.25rem 1rem;
  border: 1px solid var(--bs-primary);
  border-radius: 0.25rem;
  transform: translateX(-50%);
  white-space: nowrap;
  background-color: #fff;
}
.RangeSlider .RangeSlider-Track .badge {
  --bs-badge-padding-x: 0.5rem;
  --bs-badge-padding-y: 0.5rem;
  --bs-badge-font-size: 1rem;
}
.RangeSlider .RangeSlider-Track .badge.RangeSlider-Handle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 100%;
  white-space: nowrap;
  color: var(--bs-light);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}`, "",{"version":3,"sources":["webpack://./src/components/RangeSlider/styles.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,cAAA;AACF;AAAE;EACE,qBAAA;EACA,cAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;AAEJ;AAAM;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,8BAAA;EACA,WAAA;EACA,UAAA;EACA,kCAAA;AAER;AAAM;EACE,kBAAA;EACA,yBAAA;EACA,SAAA;EACA,kCAAA;EACA,mBAAA;AAER;AACQ;EACE,+BAAA;AACV;AAGQ;EACE,mCAAA;AADV;AAKI;EACE,YAAA;EACA,sBAAA;AAHN;AAIM;EACE,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,qBAAA;EACA,mCAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,sBAAA;AAFR;AAKI;EACE,4BAAA;EACA,4BAAA;EACA,0BAAA;AAHN;AAIM;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,sBAAA;EACA,4DAAA;AAFR","sourcesContent":[".RangeSlider {\n  display: block;\n  height: 3.5rem;\n  .RangeSlider-Track {\n    display: inline-block;\n    height: 0.5rem;\n    width: 100%;\n    margin: 0;\n    padding: 0;\n    .RangeSlider-Tick {\n      &:before {\n        content: '';\n        position: absolute;\n        left: 0;\n        background: rgba(0, 0, 0, 0.2);\n        height: 5px;\n        width: 2px;\n        transform: translate(-50%, 0.7rem);\n      }\n      .RangeSlider-TickLabel {\n        position: absolute;\n        color: rgba(0, 0, 0, 0.5);\n        top: 100%;\n        transform: translate(-50%, 1.2rem);\n        white-space: nowrap;\n      }\n      &.first {\n        .RangeSlider-TickLabel {\n          transform: translate(0, 1.2rem);\n        }\n      }\n      &.last {\n        .RangeSlider-TickLabel {\n          transform: translate(-100%, 1.2rem);\n        }\n      }\n    }\n    .RangeSlider-Segment {\n      height: 100%;\n      border: 1px solid #ccc;\n      .RangeSlider-Segment-Tooltip {\n        display: inline-block;\n        position: relative;\n        top: -2.5rem;\n        left: calc(50%);\n        margin: auto;\n        padding: 0.25rem 1rem;\n        border: 1px solid var(--bs-primary);\n        border-radius: 0.25rem;\n        transform: translateX(-50%);\n        white-space: nowrap;\n        background-color: #fff;\n      }\n    }\n    .badge {\n      --bs-badge-padding-x: 0.5rem;\n      --bs-badge-padding-y: 0.5rem;\n      --bs-badge-font-size: 1rem;\n      &.RangeSlider-Handle {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 1.5rem;\n        height: 1.5rem;\n        border-radius: 100%;\n        white-space: nowrap;\n        color: var(--bs-light);\n        transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
